(function () {
  var img = document.querySelector(".ha-home-shell .home-hero__media img");
  if (!img) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (window.matchMedia("(pointer: coarse)").matches) return;

  var ticking = false;

  function update() {
    img.style.setProperty("--para", Math.min(window.scrollY * 0.16, 150).toFixed(1) + "px");
    ticking = false;
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  update();
})();
